module.exports = __webpack_public_path__ + "img/colective.6a4597e6.png";